export const CONNECTION_REQUEST = "CONNECTION_REQUEST"
export const CONNECTION_SUCCESS = "CONNECTION_SUCCESS"
export const CONNECTION_FAILED = "FORGET_PASSWORD_ERROR"
export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT"
